import { makeStyles } from "@mui/styles";
import { fieldContainer, fieldLabel, fieldInput } from "../Form/fieldStyles";

const useStyles = makeStyles(() => ({
  container: fieldContainer,
  label: fieldLabel,
  textField: fieldInput,
}));

export default useStyles;
